import { render } from "./ChangePassword.vue?vue&type=template&id=50cf7b63&scoped=true&lang=pug"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=50cf7b63&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-50cf7b63"

export default script